import { get } from 'lodash-es';
import { F as FocusTrap, B as BxfPositionConstants } from './p-31d5cbf5.js';
import { d as BxfOverlayController } from './p-7397c455.js';
import { A as AriaAttr } from './p-d7c3b756.js';

const { MENU_CONTAINER } = BxfPositionConstants.STRING;
class BxfOverlayMenuController extends BxfOverlayController {
    host;
    parentElement;
    targetElement;
    sourceElement;
    updateStateCallback;
    options;
    isOutsideOverlayCallback;
    constructor(host, parentElement, targetElement, sourceElement, updateStateCallback, options = {}, isOutsideOverlayCallback) {
        super(host, parentElement, targetElement, sourceElement, updateStateCallback, options, isOutsideOverlayCallback);
        this.host = host;
        this.parentElement = parentElement;
        this.targetElement = targetElement;
        this.sourceElement = sourceElement;
        this.updateStateCallback = updateStateCallback;
        this.options = options;
        this.isOutsideOverlayCallback = isOutsideOverlayCallback;
    }
    appendToContainer(element) {
        super.createOverlayContainer();
        super.appendToContainer(element, MENU_CONTAINER);
    }
    /**
     * Traverse target element and its shadow root until it is focusable
     */
    getMenuTarget() {
        let target = this.targetElement;
        while (target) {
            const firstFocusable = FocusTrap.firstTabbable(target);
            if (firstFocusable) {
                return firstFocusable;
            }
            target = target.shadowRoot;
        }
        return null;
    }
    /**
     * Set aria-expanded to given value for menu target (assuming this is the first
     * 	focusable element in the target)
     * @param val
     */
    toggleExpanded(val) {
        const menuTarget = this.getMenuTarget();
        if (menuTarget) {
            menuTarget.setAttribute(AriaAttr.EXPANDED, val);
        }
    }
    /**
     * Open overlay and set aria-expanded to true on target
     */
    openOverlayWithPosition() {
        super.openOverlayWithPosition();
        if (!get(this.options, 'isFlyoutMenu', false)) {
            this.toggleExpanded('true');
        }
    }
    /**
     * Close overlay and set aria-expanded to false on target
     * 	if target is not flyout trigger
     * @param isMouseFocus
     */
    close(isMouseFocus = false) {
        super.close(isMouseFocus);
        if (!get(this.options, 'isFlyoutMenu', false)) {
            this.toggleExpanded('false');
        }
    }
}

export { BxfOverlayMenuController as B };
